import axios from 'axios';
import { User } from '../types/user';
import { Report } from '../types/report';
import { API_URL, axiosInstance } from './api_config';



export const fetchDashboardReport = async (
    userId: string,
    params?: { start_date?: string; end_date?: string }
): Promise<Report> => {
    const payload: any = { user_id: userId };
    if (params?.start_date && params?.end_date) {
        payload.start_date = params.start_date;
        payload.end_date = params.end_date;
    }
    const response = await axiosInstance.post(`${API_URL}/fetch_dashboard_report`, payload);
    return response.data;
}

export const fetchDashboardReportForUser = async (
    userId: string,
    params?: { start_date?: string; end_date?: string }
): Promise<Report> => {
    const payload: any = { user_id: userId };
    if (params?.start_date && params?.end_date) {
        payload.start_date = params.start_date;
        payload.end_date = params.end_date;
    }
    const response = await axiosInstance.post(`${API_URL}/fetch_user_dashboard_report`, payload);
    return response.data;
}

export const fetchNonGeneratingUsers = async () => {
    const response = await axiosInstance.get(`${API_URL}/fetch_non_generating_users`);
    return response.data;
}
